import { useRef } from "react";
import {
  // ArrowContainer,
  LeftContent,
  StyledVideo,
  UploadVideoContainer,
  UploadVideoButton,
  DeleteButton,
  ContainerWrapper,
  UploadVideoTitle,
  UploadVideoDesc,
  SectionLabel,
} from "./ExtendVideo.styles";
import { ReactComponent as UploadCloudIcon } from "../../assets/icons/upload-cloud.svg";
import { selectSelectedCollection } from "../../store/slices/model/slice";
import { useSelector } from "react-redux";
import { MAX_VIDEO_SIZE } from "../../utils/constants";
import { toast } from "sonner";

import LottieIcon from "../../components/LottieIcon/LottieIcon";
import deleteAnimation from "../../assets/animations/trash.json";
// import TermsCheckboxComponent from "../TermsCheckboxComponent/TermsCheckboxComponent";

const ExtendVideo = ({
  generateContainer,
  uploadedVideo,
  setUploadedVideo,
  uploadedVideoRef,
  // showOutline,
  // agreeTos,
  // handleCheckboxClick,
  // shouldShake,
}) => {
  const fileInputRef = useRef();
  const collection = useSelector(selectSelectedCollection);

  if (!collection) {
    return null;
  }

  const handleFileChange = (e) => {
    const { files } = e.target;

    const file = files[0];

    if (
      file &&
      (file.type === "video/mp4" || file.type.startsWith("video/quicktime"))
    ) {
      if (file.size > MAX_VIDEO_SIZE) {
        toast.error("Video must be smaller than 30MB");
        return;
      }
      setUploadedVideo({ file, url: URL.createObjectURL(file) });
    } else {
      toast.error("Unsupported media type.");
    }
  };

  return (
    <ContainerWrapper>
      <SectionLabel>Before</SectionLabel>
      <LeftContent>
        <UploadVideoContainer>
          {uploadedVideo && (
            <DeleteButton
              onClick={() => {
                setUploadedVideo(null);
              }}
            >
              <LottieIcon
                animationData={deleteAnimation}
                trigger="hover"
                size={24}
              />
            </DeleteButton>
          )}
          {uploadedVideo ? (
            <StyledVideo
              src={uploadedVideo?.url}
              ref={uploadedVideoRef}
              autoplay
            />
          ) : (
            <UploadVideoButton onClick={() => fileInputRef.current?.click()}>
              <UploadCloudIcon />
              <UploadVideoTitle>Upload Video</UploadVideoTitle>
              <UploadVideoDesc>
                The last frame of the video you upload will be used as the
                input.
              </UploadVideoDesc>
            </UploadVideoButton>
          )}

          <input
            type="file"
            ref={fileInputRef}
            accept="video/mp4,video/quicktime"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </UploadVideoContainer>
        {generateContainer}
        {/* <TermsCheckboxComponent
          handleCheckboxClick={handleCheckboxClick}
          agreeTos={agreeTos}
          shouldShake={shouldShake}
          showOutline={showOutline}
          offMarginTop
          offHorizontalMargin
        /> */}
      </LeftContent>
      {/* 
      <ArrowContainer>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 4.5L11.25 9L6.75 13.5"
            stroke="var(--color-brand-400)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ArrowContainer> */}
    </ContainerWrapper>
  );
};

export default ExtendVideo;
